// for development purpose
if (process.env.NODE_ENV === 'development') {
  // Must use require here as import statements are only allowed
  // to exist at top-level.
  require('preact/debug');
}

import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom'
import './assets/style/app.scss';
import Home from "./screens/Home";
import { init, browserTracingIntegration, captureConsoleIntegration } from "@sentry/react";
import {sentry_key} from "./config/constant";

if (sentry_key) {
  init(
    {
      dsn: sentry_key,
      integrations: [
        browserTracingIntegration(),
        captureConsoleIntegration({levels: ['warn', 'error', 'debug', 'assert']}),
      ],
    },
  );
}

window.Interval = []
window.Timeout = []

ReactDOM.render(
  <Home />,
  document.getElementById('root')
)
